<template lang="pug">
  .gw-popup(v-if="isShowTerms" :class="getPopupClass")
    .gw-popup__content
      section.gw-form
        .gw-form__heading(v-if="showHeading")
          a.gw-form__logo(:class="platform", :href="platform_data[platform]")

        .gw-form__content
          h3.gw-form__title {{$t('terms.title')}}
          p.gw-form__subtitle {{$t('terms.description')}}

          .gw-form__agreement-block
            .gw-form__block
              .gw-form__checkbox.gw-checkbox
                input#gw-terms-agreement.gw-checkbox__input(type="checkbox", v-model="agree")
                label.gw-checkbox__label(for="gw-terms-agreement")
                  span.gw-form__agreement.gw-form__agreement_lg(v-html="$t('terms.terms_agreement', {links: buildLinksList})")

          .gw-form__submit

            button.gw-form__btn.gw-btn(@click="acceptTerms" :disabled="!agree") {{$t("terms.button")}}


</template>
<script>
import TermsLinksMixin from "../../mixins/terms/TermsLinksMixin";

export default {
  mixins: [TermsLinksMixin],

  props: {
    showHeading: {
      type: Boolean,
      default: true,
    },
    platform: {
      type: String,
      default: "mygames",
    },
    project: {
      type: String,
      default: "",
    },
    gcMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // hack for ww3, we don't need an initial request there
      dynamic: this.project !== "ww3",
      platform_data: {
        mygames: "https://my.games/",
        vkplay: "https://vkplay.ru/",
      },
    };
  },
  computed: {
    getPopupClass() {
      return {
        "gw-popup--mode_gc": this.gcMode,
      };
    },
  },

  created() {
    if (this.$nuxt) {
      this.getTermsInfo(true);
    } else {
      document.addEventListener("init_vue_components", () => {
        this.getTermsInfo();
      });
    }
  },
};
</script>

<style lang="css" scoped>
@import "../../styles/gw-popup.css";
</style>
